import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";

@Injectable()
export class CommunicationService {



  public expandWrapper: Subject<any> = new Subject();
  public toggleSidemenu: Subject<any> = new Subject();
  public sidebarOf: Subject<any> = new Subject();




  public userFirstName: Subject<any> = new Subject();
  public userLastName: Subject<any> = new Subject();

  public selectedPercentage: Subject<any> = new Subject();
  public percentageDiff: Subject<any> = new Subject();
  public scrollDataChanged: Subject<any> = new Subject();

  public sortCompareChartsChanged: Subject<any> = new Subject();
}







// WEBPACK FOOTER //
// ./src/app/shared/services/communication.service.ts